import axios, { InternalAxiosRequestConfig, AxiosError, AxiosResponse} from 'axios'

// config
import env from '../config/env';

const headers = {}

const axiosUpload = axios.create({
    baseURL: env.baseURL,
    headers
})

axiosUpload.interceptors.request.use((config: InternalAxiosRequestConfig)  => {
    const serial: string | null | undefined = localStorage.getItem('@serial');
    if (serial) {
        config.headers.Authorization = `bearer ${serial}`;
    }
    config.headers.Accept = 'application/json';
    config.headers['Content-Type'] = 'multipart/form-data';

    return config;

}, (error: Promise<AxiosError>) => {
    return Promise.reject(error);
})

axiosUpload.interceptors.response.use(
    (response: any): Promise<AxiosResponse> => {
        return response;
    }, (error:  AxiosError): Promise<AxiosError> => {
        if (error?.response?.status === 401 && window.location.pathname !== '/login') {
            window.location.href = '/login'
        }
        return Promise.reject(error)
    }
)

export default axiosUpload;